import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=58576bdd&scoped=true&"
import script from "./AuditLog.vue?vue&type=script&lang=ts&"
export * from "./AuditLog.vue?vue&type=script&lang=ts&"
import style0 from "./AuditLog.vue?vue&type=style&index=0&id=58576bdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58576bdd",
  null
  
)

export default component.exports